import React from "react";
import TableViewer from "../TableViewer";
import { v4 as uuidv4 } from 'uuid';
import { nanoid } from "nanoid";
import SocketServices from "../../utils/socket.services";
import { checkTextTranslation, checkTranslation, getOneThing, imageAddress, timeToTimeAgo, translate } from "../../utils/useful";
import HttpServices from "../../utils/Http.services";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from '../../stores/actionsList';
import MessageStatusView from "../views/messenger/boxes/MessageStatusView";


class UpdatesWidget extends React.Component {

    state = {
        data: [],
        baseHeaders: [
            { key: 'cDate', type: 'DateInput', information: { label: '{{lang}}date', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertName', required: true } },
            // { key: 'family', type: 'TextInput', information: { label: '{{lang}}family', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertFamily', required: true } },
            // { key: 'education', type: 'TextInput', information: { label: '{{lang}}Education', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertEducation', required: true } },
            // { key: 'age', type: 'TextInput', information: { label: '{{lang}}age', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertage', required: true } }
        ],
        headers: [
            // { key: 'cDate', type: 'DateInput', information: { label: '{{lang}}date', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertName', required: true } },
            // { key: 'family', type: 'TextInput', information: { label: '{{lang}}family', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertFamily', required: true } },
            // { key: 'education', type: 'TextInput', information: { label: '{{lang}}Education', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertEducation', required: true } },
            // { key: 'age', type: 'TextInput', information: { label: '{{lang}}age', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertage', required: true } }
        ],
        list: [],
        // list: [
        //     { visitor: { fullname: 'Pouya Pezhman' } },
        //     { visitor: { fullname: 'Other User' } },
        //     { visitor: { fullname: 'Ali Salarvandian' } },
        //     { visitor: { fullname: 'Ali Panahi' } },
        //     { visitor: { fullname: 'Morshedi_00' } },
        //     { visitor: { fullname: 'Mohseni' } },
        //     { visitor: { fullname: 'Pedram Pezhman' } },
        //     { visitor: { fullname: 'Pouya Pezhman' } },
        //     { visitor: { fullname: 'Pouya Pezhman' } },
        //     { visitor: { fullname: 'Pouya Pezhman' } },
        //     { visitor: { fullname: 'Pouya Pezhman' } },
        //     { visitor: { fullname: 'Ali Salarvandian' } },
        //     { visitor: { fullname: 'Ali Panahi' } },
        //     { visitor: { fullname: 'Morshedi_00' } },
        //     { visitor: { fullname: 'Mohseni' } },


        // ],
        topicId: nanoid(10),
        currentTab: 'request'
    }




    componentDidMount() {
        this.init()
        // console.log('this.props.inbox', this.props.inbox)
        this.main.addEventListener('wheel', this.onWheel, true)
        SocketServices.addTopic(this.state.topicId, null, 'inboxUpdate', null, this.updateData)

    }

    componentWillUnmount() {
        SocketServices.removeTopic(this.state.topicId, null, 'inboxUpdate')
        this.main.removeEventListener('wheel', this.onWheel)

    }

    init() {

        let myId = this.props.user?.info?._id
        if (myId) {
            this.setState({ myId }, () => {
            })
        }

        this.fetchList()

    }




    fetchList = () => {

        let limit = 25
        if (this.props.data.limit) {
            limit = Number(this.props.data.limit)
        }


        HttpServices.request("getUpdatesList", { filter: {}, limit }, (fetchResult, fetchError, status) => {


            if (fetchError) { return }

            let data = this.state.data

            // console.log("data", fetchResult)

            data = [...data, ...fetchResult.inboxes]

            // console.log("data", data)

            this.setState({ data })
            // if (cb) { cb(fetchResult, null, status) }
        })
    }






    // getLabel(dataObject) {
    //     // console.log(dataObject)
    //     if (this.state.thing?.structure) {
    //         // let result = ''
    //         for (let i = 0; i < this.state.thing.structure.length; i++) {
    //             const structure = this.state.thing.structure[i];
    //             if (structure.dataObject == dataObject) {
    //                 return structure.label
    //             }
    //         }

    //     }
    // }
    openOne = (item) => {
        console.log('item')
    }
    showInbox = () => {

        return this.state.data?.map((item, index) => {
            let text = item.title//this.props.messengers?.object[item._id]['*lastMsg']?.text
            // if (item.type == this.state.currentTab) {
            // console.log('item.type1', item)
            if (item.applets) {
                // MESSENGER
                // console.log(item)
                let lastMsg = item ? item['lastMsg'] : null
                let systemInfo = lastMsg?.systemInfo?.name + ' ' + translate(lastMsg?.systemInfo?.type)
                let text = lastMsg?.text
                let time = lastMsg?.cDate
                let myApplet
                let myFrame
                let name
                let image
                // console.log('item.users',item)
                if (item?.type == 'group' || item?.type == 'support') {
                    image = item?.image
                    name = item?.name
                } else {
                    item.users.forEach(element => {
                        if (element?.hub?._id != this.state.myId) {
                            image = element.hub?.image
                            name = element.hub?.fullname
                        }
                    });
                }



                let deafultImage = item?.type == 'group' ? 'group' : 'profile'

                item.frames?.forEach(element => {
                    if (element?.hub == this.state.myId) {
                        myFrame = element.frame
                    }
                });

                item.applets?.forEach(element => {
                    if (element?.hub == this.state.myId) {
                        myApplet = element.frame
                    }
                })

                let notifcount = this.props.inbox?.messengers?.[item._id]?.count


                return (

                    <button className=" pb-2 pt-2 flexc w-100 " key={index} style={{ transition: 'all 0.5s', cursor: 'pointer', borderBottom: '1px solid #f6f6f6', }} onClick={() => { this.props.addNewWindow("hub", { path: [myApplet?.appletHub?.username, myApplet?.slug, 'admin', myFrame?._id, item._id], type: 'applet' }, "center") }}>

                        <div className='w-100 flexc' style={{ alignItems: 'flex-start' }} >

                            <div className="position-relative" >
                                <img className="mr-2" src={imageAddress(image, deafultImage, 'thumb')} style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'cover' }} />
                                <div className="position-absolute br-50 flexcc" style={this.props.language == 'fa' ? { bottom: 0, left: 65, width: 25, height: 25, border: '1px solid #eee' } : { backgroundColor: '#fff', bottom: 0, right: -8, width: 25, height: 25, border: '1px solid #eee' }}>
                                    <img className="" src={imageAddress(item?.applet?.image, 'applet', 'small')} style={{ width: 22, height: 22, borderRadius: '50%', border: '0px solid #eee' }} />
                                </div>
                            </div>


                            <div className="pld-5" style={{ width: 'calc(100% - 50px)' }}>

                                <div className="flexcb w-100">
                                    <p className="mb-0 text-bold " style={{ fontSize: 14, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTranslation(name)}</p>
                                    <p className="mb-0 text-smaller" >{checkTranslation(timeToTimeAgo(time))}</p>
                                </div>
                                <div className="flexcb w-100">
                                    <div className="flexc w-100 mt-1">
                                        {item["lastMsg"]?.sender == this.state.myId && (
                                            <div className="mrd-1">
                                                <MessageStatusView status={item["lastMsg"]?.status} colors={this.props.colors} />
                                                {/* {(item["lastMsg"].status == 0 || item["*lastMsg"].status == null) && (
                                                                            <img src="/assets/icons/applets/messenger/clock.png" width={10} style={{ opacity: 0.5 }} />
                                                                        )}
                                                                        {(item["*lastMsg"].status == 1) && (
                                                                            <img src="/assets/icons/applets/messenger/sent.png" style={{ opacity: 0.5, }} />
                                                                        )}
                                                                        {(item["*lastMsg"].status == 2) && (
                                                                            <img src="/assets/icons/applets/messenger/read.png" width={10} />
                                                                        )} */}
                                            </div>
                                        )}
                                        {(text && !lastMsg?.file) && (lastMsg?.trashed == false) ? (
                                            <>
                                                {item?.activity?.isTyping?.length > 0 ? (
                                                    <p style={{ fontSize: 12, color: '#0085ff' }}>{translate('messenger.is typing')}</p>
                                                ) : (
                                                    <p className="" style={{ color: '#777', fontSize: 12, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: "140px" }}>{checkTranslation(text)}</p>
                                                )}
                                            </>
                                        ) : (
                                            <div>
                                                {lastMsg?.trashed == true ? (
                                                    <p className="w-100" style={{ color: '#777', fontSize: 10, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: "140px" }}>{translate('messenger.This message was deleted')}</p>
                                                ) : (
                                                    <>
                                                        {lastMsg?.voice && (
                                                            <div className="flexcc">
                                                                <img className="mrd-1" src={'/assets/icons/messenger/mic-gray.svg'} height={18} />
                                                                <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.Voice')}</p>
                                                            </div>
                                                        )}
                                                        {lastMsg?.file && (
                                                            <div className="flexcc">
                                                                <img className="mrd-1" src={'/assets/icons/messenger/doc-gray.svg'} height={18} />
                                                                <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.File')}</p>
                                                            </div>
                                                        )}
                                                        {lastMsg?.video && (
                                                            <div className="flexcc">
                                                                <img className="mrd-1" src={'/assets/icons/messenger/play-gray.svg'} height={18} />
                                                                <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.Video')}</p>
                                                            </div>
                                                        )}
                                                        {lastMsg?.image && (
                                                            <div className="flexcc">
                                                                <img className="mrd-1" src={'/assets/icons/messenger/pic-gray.svg'} height={18} />
                                                                <p className="" style={{ color: '#777', fontSize: 12 }}>{translate('messenger.Image')}</p>
                                                            </div>
                                                        )}
                                                        {lastMsg?.systemInfo && (
                                                            <div className="flexcc">
                                                                <img className="mrd-1" src={'/assets/icons/messenger/systeminfo.svg'} height={18} />
                                                                <p className="" style={{ color: '#777', fontSize: 12, maxWidth: '140px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{checkTranslation(systemInfo)}</p>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    {notifcount > 0 && (
                                        <div className='white flexcc px-1' style={{ borderRadius: 20, lineHeight: 1, minWidth: "20px", minHeight: "20px", backgroundColor: '#ee5050', right: 0 }}>
                                            <span className='text-smaller'>{notifcount}</span>
                                        </div>
                                    )}
                                </div>
                                {/* {console.log('this.props.messenger?.assignee', item.status !=0)} */}
                                {/* {console.log('this.props.messenger?.assignee', this.props.messenger?.assignee)} */}
                                {this.props.applet?.settings?.type == 'support' && (
                                    <>
                                        {item?.assignee &&
                                            <div className="flexc">
                                                <p className="font-size-12 main-c2 weight-400">{translate('Assignee')}:&nbsp;</p>
                                                <p className="font-size-12 main-c2 weight-500">{item?.assignee?.hub?.fullname}</p>
                                            </div>
                                        }
                                        {/* {item.type && */}
                                        <div className="flexc">
                                            <p className="font-size-12 main-c2 weight-400">{translate('Status')} :&nbsp;</p>
                                            <p className="font-size-12 main-c2 weight-500">{this.translateStatus(item?.status)}</p>
                                        </div>
                                    </>

                                )}
                                {/* } */}
                                {/* <p className="ticket-desc">{item.description?.substr(0, 70)}{item.description?.length > 70 ? ' ...' : ''} </p> */}
                                {/* <p className="ticket-date">{moment(item.uDate).format("MMM YYYY, DD HH:mm")}</p> */}
                            </div>
                        </div>
                    </button>
                )

            } else {
                let appletId = item.applet?._id ?? item.applet
                let frameId = item.frame?._id ?? item.frame
                let hubId = item.hub?._id ?? item.hub


                return (

                    <button className=" pb-2 pt-2 flexc w-100 " key={index} style={{ transition: 'all 0.5s', cursor: 'pointer', borderBottom: '1px solid #f6f6f6', }} onClick={() => { this.props.addNewWindow("hub", { path: [item.appletHub.username, item.applet?.slug, 'admin', item.frame?._id], type: 'applet' }, "center") }}>
                        <div className="position-relative" >
                            <img className="mr-2" src={imageAddress(item?.appletHub?.image, 'profile', 'small')} style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'cover' }} />

                            {item.type == 'system' ? (
                                <div className="position-absolute br-50 flexcc" style={this.props.language == 'fa' ? { bottom: 0, left: 65, width: 25, height: 25, } : { bottom: 0, right: -8, width: 25, height: 25, }}>
                                    <img className="" src={'/assets/icons/useful/3d-bell.png'} style={{ width: 22, height: 22, }} />
                                </div>
                            ) : (
                                <div className="position-absolute br-50 flexcc" style={this.props.language == 'fa' ? { bottom: 0, left: 65, width: 25, height: 25, border: '1px solid #eee' } : { backgroundColor: '#fff', bottom: 0, right: -8, width: 25, height: 25, border: '1px solid #eee' }}>
                                    <img className="" src={imageAddress(item?.applet?.image, 'applet', 'small')} style={{ width: 22, height: 22, borderRadius: '50%', border: '0px solid #eee' }} />
                                </div>

                            )}
                        </div>
                        <div className="pld-5 w-100">
                            <div className="flexc w-100" style={{ alignItems: 'flex-start' }}>

                                {item.type == 'system' ? (
                                    <p className="font-size-14 main-c2 text-semibold my-0" style={{}}>{translate("System update")}</p>
                                ) : (
                                    <p className="font-size-14 main-c2 text-semibold my-0" style={{}}>{item?.frame?.name} - {item?.applet?.name}</p>
                                )}

                                {/* {this.props.messengers?.notifications[item?._id] != null && this.props.messengers?.notifications[item?._id] != 0 && (
                                    <div className='white flexcc mld-2' style={{ borderRadius: 20, minWidth: 20, height: 20, lineHeight: 1, backgroundColor: '#ee5050', right: 0 }}>
                                        <span className='text-smaller'>{this.props.messengers.notifications[item?._id]}</span>
                                    </div>
                                )} */}

                            </div>


                            <p className="my-0 text-start" style={{ color: '#777', fontSize: 12 }}>{item.appletHub?.fullname}</p>


                            {/* {text ? (
                            <p className="my-0" style={{ color: '#999', fontSize: 12 }}>{text.substring(0, 40)}{text.length > 40 ? '...' : ''}</p>
                        ) : (
                            <p className="my-0" style={{ color: '#999', fontSize: 12 }}><img className="mrd-1" src={'/images/clone.svg'} height={10} style={{ opacity: 1, filter: 'brightness(0)' }} />FORM</p>
                        )} */}
                            {/* <p className="ticket-desc">{item.description?.substr(0, 70)}{item.description?.length > 70 ? ' ...' : ''} </p> */}
                            {/* <p className="ticket-date">{moment(item.uDate).format("MMM YYYY, DD HH:mm")}</p> */}
                        </div>

                        <div className="d-flex flex-column prd-2" style={{ alignItems: 'flex-end' }}>

                            <div className='flexcc mld-2 mb-1'>
                                <span className='text-smaller'>{timeToTimeAgo(item.uDate)}</span>
                            </div>

                            {item.type == 'system' ? (
                                <>
                                    {this.props.inbox?.categorizer?.system?.hubs && this.props.inbox?.categorizer?.system?.hubs[hubId]?.count && (
                                        <div className="flexcc">
                                            <div className='white flexcc mld-2 px-1' style={{ borderRadius: 20, minWidth: 20, height: 20, lineHeight: 1, backgroundColor: '#ee5050', right: 0 }}>
                                                <span className='font-size-12'>{this.props.inbox?.categorizer?.system?.hubs[hubId]?.count}</span>
                                            </div>
                                        </div>
                                    )}
                                </>

                            ) : (
                                <>
                                    {this.props.inbox.object[appletId]?.frames?.[frameId]?.count && (
                                        <div className="flexcc">
                                            <div className='white flexcc mld-2 px-1' style={{ borderRadius: 20, minWidth: 20, height: 20, lineHeight: 1, backgroundColor: '#ee5050', right: 0 }}>
                                                <span className='font-size-12'>{this.props.inbox.object[appletId]?.frames?.[frameId]?.count}</span>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                    </button >
                )
            }
            // } else if (item.type == 'notifier' && this.state.currentTab == 'frame') {
            //     return (
            //         <div className=" pb-2 pt-2 flexc w-100 " key={index} style={{ transition: 'all 0.5s', cursor: 'pointer', borderBottom: '1px solid #f6f6f6', }} onClick={() => this.openOne(item)}>
            //             <button onClick={() => { this.props.addNewWindow("hub", { path: [item.sender.username], type: 'hub' }, "center") }}>
            //                 <img className="mr-2" src={('/assets/icons/applets/' + ((item.applet?.features && item.applet?.features[0]) ? String(item.applet?.features[0]).toLowerCase() : String(item.applet?.type).toLowerCase()) + ".png")} style={{ width: '40px', height: 40, borderRadius: 40, objectFit: 'cover' }} />
            //             </button>
            //             <div className="px-1 w-100">
            //                 <p className="font-size-14 main-c2 text-semibold my-0" style={{}}>{item?.frame?.name}</p>
            //                 <div className="flexc w-100" style={{}}>

            //                     {text ? (
            //                         <p className="my-0" style={{ color: '#999', fontSize: 12 }}>{text.substring(0, 40)}{text.length > 40 ? '...' : ''}</p>
            //                     ) : (
            //                         <p className="my-0" style={{ color: '#999', fontSize: 12 }}><img className="mrd-1" src={'/images/clone.svg'} height={10} style={{ opacity: 1, filter: 'brightness(0)' }} />FORM</p>
            //                     )}
            //                     {item.count && (
            //                         <div className='white flexcc mld-2' style={{ borderRadius: 20, minWidth: 20, height: 20, lineHeight: 1, backgroundColor: '#ee5050', right: 0 }}>
            //                             <span className='text-smaller'>{item.count}</span>
            //                         </div>
            //                     )}
            //                 </div>

            //             </div>

            //         </div>
            //     )
            // }
        })

    }
    updateData = (newData, type) => {

        let data = this.state.data


        if (type == 'updateActions') {

            data.forEach(element => {

                if (element._id == newData?.messenger) {

                    if (newData.activity == "isTyping") {
                        let i

                        if (!element.activity) {
                            element.activity = { isTyping: [] }
                        }
                        element.activity.isTyping.forEach((act, index) => {
                            if (act.user == newData.user) {
                                i = index
                            }
                        });

                        if (newData.value == true && i == null) {
                            element.activity.isTyping.push({ user: newData.user })
                        }
                        if (newData.value == false) {

                            if (i != null) {
                                element.activity.isTyping.splice(i, 1)
                            }

                            // element.activity.isTyping.push({ user: newData.user })
                        }
                    }
                }
            })
        }




        if (type == 'messageSeen') {

            data.forEach(element => {

                if (element._id == newData?.messenger && element.lastMsg?._id == newData?.message) {
                    element.lastMsg.status = 2
                }
            })
        }


        if (type == 'newMessage') {
            let found = false
            data.forEach(element => {

                if (element._id == newData?.messenger?._id) {
                    if (newData?.message.sequence > element.sequence) {
                        element.lastMsg = newData?.message
                        element.uDate = newData?.message?.cDate
                        found = true
                    }
                }

            });

            if (!found) {
                newData.messenger.lastMsg = newData?.message
                data.push(newData?.messenger)
            }

        }
        if (type == 'newInbox' || type == 'updateInbox') {

            let found = false
            data.forEach((element, index) => {
                if (element._id == newData._id) {

                    data[index] = { ...newData }
                    found = true
                }
            });

            if (!found && newData.type != 'request') {
                data.push(newData)
            }
        }


        data.sort((a, b) => new Date(b.uDate).getTime() - new Date(a.uDate).getTime())

        this.setState({ data })

    }

    onWheel = (e) => {
        // console.log(e)
        e.stopPropagation()
    }

    openRequests = (item) => {
        console.log(item)
    }


    showRequests = (hubRequests) => {

        let notifcount = hubRequests?.count
        let image = ''
        let name = 'Connection Requests'
        return (
            <button className=" mb-1 w-100" style={{ paddingTop: 12 }} onClick={() => this.openRequests(hubRequests)}>

                <div className="px-4 position-relative h-100">
                    <div className="br-8  " style={{ top: -10, width: 'calc(100% - 40px)', height: 50, position: 'absolute', backgroundColor: '#f0f2f450' }}>
                    </div>
                </div>

                <div className="px-2 position-relative h-100">
                    <div className="br-8  " style={{ top: -5, width: 'calc(100% - 12px)', height: 50, position: 'absolute', backgroundColor: '#f0f2f490' }}>
                    </div>
                </div>


                <div className="br-8 px-2 w-100 position-relative" style={{ backgroundColor: '#f0f2f4', border: '1px solid #f0f0f0' }}>
                    <div className=" pb-2 pt-2 flexc w-100 " style={{ transition: 'all 0.5s', cursor: 'pointer', borderBottom: '1px solid #f6f6f6', }} onClick={() => { }}>

                        <div className='w-100 flexc'  >

                            <div className="position-relative" >
                                <img className="mr-2" src={imageAddress(hubRequests?.info?.image, 'profile', 'thumb')} style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'cover' }} />
                                {/* <div className="position-absolute br-50 flexcc" style={this.props.language == 'fa' ? { bottom: 0, left: 65, width: 25, height: 25, border: '1px solid #eee' } : { backgroundColor: '#fff', bottom: 0, right: -8, width: 25, height: 25, border: '1px solid #eee' }}>
                                        <img className="" src={imageAddress(item?.applet?.image, 'applet', 'small')} style={{ width: 22, height: 22, borderRadius: '50%', border: '0px solid #eee' }} />
                                    </div> */}
                            </div>


                            <div className="pld-4 flexcb" style={{ width: 'calc(100% - 50px)' }}>

                                <div className="text-start">
                                    <p className="mb-0 text-bold " style={{ fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTranslation(name)}</p>
                                    <p className="mb-0 text-smaller" >{translate('For')} {hubRequests?.info?.fullname} </p>
                                </div>
                                <div className="flexcb ">

                                    {notifcount > 0 && (
                                        <div className='white flexcc px-1' style={{ borderRadius: 20, lineHeight: 1, minWidth: "20px", minHeight: "20px", backgroundColor: '#ee5050', right: 0 }}>
                                            <span className='text-smaller'>{notifcount}</span>
                                        </div>
                                    )}
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </button>
        )

    }



    render() {
        let requests = this.props.inbox?.categorizer?.request
        return (
            <div ref={el => this.main = el} className="w-100 h-100" style={{ minHeight: 300 }} >
                {/* <div style={{ position: 'absolute', top: 40, backgroundColor: '#ffffffee', padding: '3px 20px', borderRadius: '4px 4px 0px 0px' }}>
                    <p style={{ color: '#9ab', fontSize: 12 }}>Listed Data count {this.state.data?.length}</p>
                </div> */}
                <div className="flexcb flex-wrap pb-2 " >

                    <div className=' '>
                        <p className='text-bold text-semibig '>{translate("Latest updates")}</p>
                        {/* <p className="text-semibold text-smaller" style={{}}>{translate("This is a new test text")}</p> */}
                    </div>

                    <div className="flexc " >
                        <button className={""} onClick={() => { this.setState({ currentTab: 'request' }) }} style={{ color: this.state.currentTab == 'request' ? 'rgb(88, 86, 214)' : '#999', borderBottom: this.state.currentTab == 'request' ? '2px solid rgb(88, 86, 214)' : '2px solid transparent' }}>
                            <p className={"px-2 py-1 flexcc weight-600 text-small "}>{translate("Inboxes")}</p>
                        </button>
                        <button className={" "} onClick={() => { this.setState({ currentTab: 'frame' }) }} style={{ color: this.state.currentTab == 'frame' ? 'rgb(88, 86, 214)' : '#999', borderBottom: this.state.currentTab == 'frame' ? '2px solid rgb(88, 86, 214)' : '2px solid transparent' }}>
                            <p className={"px-2 py-1 flexcc weight-600 text-small "}>{translate("Notifications")}</p>
                        </button>
                    </div>

                </div>

                {(this.state.data?.length == 0 && (!requests?.hubs || Object.values(requests.hubs)?.length == 0)) && (
                    <div className="flexcc flex-column px-3 pb-4">
                        <img className="w-50 mt-4" src="/assets/icons/useful/notification-bell 2.png" style={{ maxHeight: 120, objectFit: 'contain' }} />
                        <p className="text-semibold semibig mt-2">{translate("No Updates Yet")}</p>
                        <p className='text-muted text-smaller mt-2' style={{ maxWidth: 390 }}>Here you can see the newest updates from all the applets and hubs. This helps you to be updated about all the notifications and required actions</p>

                    </div>
                )}
                <div className="w-100 sc-gray2 h-100" style={{ overflow: 'auto' }}>
                    {requests?.hubs && Object.values(requests.hubs)?.length > 0 && (
                        <>
                            {Object.values(requests.hubs).map((hubRequests, index) => {
                                if (hubRequests.count > 0)
                                    return this.showRequests(hubRequests)
                            })}

                        </>
                    )}


                    {this.showInbox()}


                </div>

            </div >
        )
    }
}



// export default UpdatesWidget;

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connection: state.connection, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdatesWidget);
